import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn } from '@angular/forms';
//import { TeamService } from '../../app/Master/team/team.service';
import { DatabaseService } from '../../app/Master/database/database.service';
import { CommondialogComponent } from '../../app/Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { TeamMgt } from './teammgt';
import { TeamMgtService } from './teammgt.service';
import { MenurightsComponent } from '../../app/Shared/menurights/menurights.component';
import * as $ from 'jquery'; declare let $: any;
import { UserService } from '../Master/user/user.service';
import { LocalService } from '../local.service';

@Component({
  selector: 'app-teammgt',
  templateUrl: './teammgt.component.html',
  styleUrls: ['./teammgt.component.css']
})
export class TeammgtComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Team Management';
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean; _menuId: any;
  _teamList: any = [];
  _teamListactive: any = [];
  _teamListTmp: any = []; _databaseList: any = []; _databaseListTmp: any = []; _dropdownSettings: any;
  _selectedItems: any = []; _menuList: any = []; _actionList: any[]; _actiondropdownSettings: any; _mappedMenuActionList: any; actionArray = [];
  p: number = 1; searchText: string; itemsPerPage: number = 10; actionList = []; userid: number; _action: string; confmsg: string; msg: string; checkedAll: boolean;
  _teamId: any; textBoxTocuhed: boolean;
  //actions = [{ 'actionid':'1','action': 'Ready only' }, { 'actionid':'2','action': 'Add' }, { 'actionid':'3','action': 'Edit' }, {'actionid':'4', 'action': 'Delete' }];
  actions = [];

  //formgroup
  TeamMgtForm: FormGroup;
  teamMgmts: TeamMgt[];
  teamMgmt: TeamMgt;
  submitted = false;
  currentteam: string;
  checkedstatus: boolean;

  //request type
  _requestTypeSettings: any;
  _requestTypeList: any = [];
  _requestTypeListTmp: any = [];
  _selectedRequestType: any = [];
  showall: boolean = true;
  showallstatus: boolean = false;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private databaseService: DatabaseService,
    private formBuilder: FormBuilder,
    private teamMgtService: TeamMgtService,
    private dialogService: DialogService, private _menuRights: MenurightsComponent, 
    private userservice: UserService, private localService: LocalService
  ) {
    //code to get relavent menu id
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Team Management_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Team Management_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Team Management_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Team Management_action');
    }
  }

  ngOnInit() {
    
    this.checkIsMenuMapped();

    this.TeamMgtForm = this.formBuilder.group({
      teammgtid: [''],
      teammgt: ['', [Validators.required]],
      description: ['', [Validators.required]],
      databasemapped: [''],
      menumapped: [''], requestmapped: ['']//, actions: new FormArray([])
      //actions: new FormArray([], minSelectedCheckboxes(0))
    });
    
    this.LoadExisitingTeamList();
    this.LoadExisitingDatabaseList();
    this.LoadRequestTypeList();
    this._selectedItems = [];
    this._selectedRequestType = [];
    this._action = 'add';
    this._teamId = ''; //this.actionArray = [];
    this.checkedAll = true; this.currentteam = ''; this.textBoxTocuhed = false;
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
    // $('body').addClass('nav-sm').removeClass('nav-md');
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedteammgmt");
    console.log(arrays);
    let data = arrays.find(ob => ob['name'] === 'Team Management');    
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedteammgmt","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedteammgmt",null);
      this.router.navigate(["home"]); 
    }
  }

  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  key: string = 'team'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  get formdata() { return this.TeamMgtForm.controls; }
  PostTeamMgt(teamMgmt: TeamMgt) {
    this.submitted = true;
    if (this.TeamMgtForm.valid) {
      //this.userid = +localStorage.getItem('userid');
      this.userid = +this.localService.getJsonValue('userid');
      var groupDatabaseMapped = {}; var groupRequestMapped = {};
      if (this._selectedItems == undefined || this._selectedItems == null || this._selectedItems.length == 0) {
        this.toastr.error('Atleast any one database should get selected');
        return;
      }
      //if (this._selectedRequestType.length == 0) {
      //  this.toastr.error('Atleast any one request type should get selected');
      //  return;
      //}
      this.checkedstatus = this._menuRights.getselectedmenuscheck();
      if (this.checkedstatus == false) {
        this.toastr.error('Atleast one menus with required rights should get selected');
        return;
      }
      this.actionArray = this._menuRights.getselectedmenus();
      //console.log(JSON.stringify(this.actionArray));
      teamMgmt.menumapped = JSON.stringify(this.actionArray);//this._mappedMenuActionList);
      groupDatabaseMapped['databasemapped'] = this.databaseSaveStructure(this._selectedItems, 'database');// this._selectedItems;
      groupRequestMapped['requestmapped'] = this.databaseSaveStructure(this._selectedRequestType, 'request');
      teamMgmt.databasemapped = JSON.stringify(groupDatabaseMapped);
      teamMgmt.requestmapped = JSON.stringify(groupRequestMapped);
      teamMgmt.teammgtid = 0;

      //adding new team information
      if (this._action == 'add') {
        teamMgmt.createdby = this.userid;
        teamMgmt.active = 1;
        this.teamMgtService.Post(teamMgmt).subscribe(
          (res) => {
            if (res.body != 0) {
              this.toastr.success('Data added successfully');
              this.LoadExisitingTeamList();
              this.clearForm();
            }
            else { this.toastr.error('Team exists already'); }
          }, error => {
            this.toastr.error(error);
            //console.log(error);
          });
      }
      //updating the team information
      if (this._action == 'update') {
        teamMgmt.modifiedby = this.userid;
        teamMgmt.teammgtid = this._teamId;
        //check if user exists for this team
        var allUserList = [];
        this.userservice.Get().subscribe(res => {
          if (res != undefined && res != null && res.length != 0) {
            allUserList = res.filter(e => e.teamid == teamMgmt.teammgtid);
            if (allUserList.length != 0) {
              let showpopup = this.dialogService.addDialog(CommondialogComponent,
                {
                  title: 'Confirmation',
                  message: 'Would you like to proceed the same changes for mapped users? ',
                  hclass: 'modelsuccess',
                  oktext: 'Yes',
                  canceltext: 'No',
                  okshow: true,
                  cancelshow: true
                })
                .subscribe((isConfirmed) => {
                  if (isConfirmed) {
                    this.teamMgtService.UpdateTeamWithAllUser(teamMgmt).subscribe(
                      (res) => {
                        if (res.body != 0) {
                          this.toastr.success('Data updated for team and mapped user successfully');
                          this.LoadExisitingTeamList();
                          this.clearForm();
                        }
                        else { this.toastr.error('Team exists already'); }
                      }, error => {
                        this.toastr.error(error);
                      })
                  }
                  else {
                    this.teamUpdate(teamMgmt);
                  }
                });
            }
            else {
              this.teamUpdate(teamMgmt);
            }
          }
        });

      }
    }
  }
  teamUpdate(teamMgmt) {
    this.teamMgtService.Put(teamMgmt).subscribe(
      (res) => {
        if (res.body != 0) {
          this.toastr.success('Data updated successfully');
          this.LoadExisitingTeamList();
          this.clearForm();
        }
        else { this.toastr.error('Team exists already'); }
      }, error => {
        this.toastr.error(error);
      });
  }
  chkArrayTouched() {
    this.textBoxTocuhed = true;
  }

  onItemSelect(item: any) {
    this.textBoxTocuhed = true;
  }

  onItemDeSelect(item: any) {
    this.textBoxTocuhed = true;
  }
  clearForm() {
    this.submitted = false;
    this.checkedAll = true;
    this._action = 'add';
    this._selectedItems = [];
    this._selectedRequestType = [];
    this.actionArray = [];
    this.TeamMgtForm.controls['databasemapped'].setValue(this._selectedItems);
    this.TeamMgtForm.controls['requestmapped'].setValue(this._selectedRequestType);
    this.TeamMgtForm.reset();
    this.currentteam = '';
    this.textBoxTocuhed = false;
    this._menuRights.reset();
  }
  onCheckboxChange(id, data, isChecked: boolean) {
    if (isChecked) {
      this.actionArray.push({ 'menuid': id, 'action': data });
      let e2 = document.getElementById(id);
      (<HTMLInputElement>e2).checked = true;
    }
    else {
      this.actionArray.splice(this.actionArray.findIndex(e => e.action == data && e.menuid === id
      ), 1);
    }
    //console.log(this.actionArray);
  }

  LoadExisitingTeamList() {
    this._teamList = [];
    this._teamListactive = [];
    this.teamMgtService.Get().subscribe(res => {
     
      this._teamList = res;
      if (this.showallstatus == true) {
        this._teamList.forEach(data => {
          if (data.active == 1) {
            this._teamListactive.push(data);
          }
        });
        this._teamList = [];
        this._teamList = this._teamListactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });
  }

  getactiveinactive(showallp) {
    this._teamListactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this._teamList.forEach(data => {
        if (data.active == 1) {
          this._teamListactive.push(data);
        }
      });
      this._teamList = [];
      this._teamList = this._teamListactive;
    }
    else {
      this.showall = true;
      this._teamList = [];
      this.LoadExisitingTeamList();
    }
  }

  LoadExisitingDatabaseList() {
    this.databaseService.Get().subscribe(res => {
      var allData = res;
      allData.forEach(data => {
        if (data.active != 0) {
          this._databaseListTmp.push({ databaseid: data.databaseid, database: data.database })
        }
      });
      this._dropdownSettings = {
        singleSelection: false,
        idField: 'databaseid',
        textField: 'database',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 7,
        allowSearchFilter: true
      };
      this._databaseList = JSON.parse(JSON.stringify(this._databaseListTmp));
      //console.log(this._databaseList);
    }, error => { this.toastr.error('Error while getting data'); });
  }

  LoadMenuList() {
    this.teamMgtService.GetMenu().subscribe(res => {
      if (res != undefined) {
        if (res.length > 0) {
          res.forEach(item => {
            var data = JSON.parse(item.spgetmenulist);
            this._menuList.push({ data })
          });
        }
      }
    },
      error => {
        //console.log(error);
      });
  }

  //form valid mail structure suit for  multi select list
  formMultiSelectStrucuture(mappedList, dbList, type) {
    var tempList = [];
    if (type == 'database') {
      if ((mappedList != null) && (mappedList.length != 0)) {
        dbList.forEach((d) => {
          mappedList.forEach((data, ind) => {
            if (data.databaseid == d.databaseid) {
              tempList.push({
                databaseid: d.databaseid, database: d.database
              });
            }
          });
        });
      }
    }
    if (type == 'request') {
      if ((mappedList != null) && (mappedList.length != 0)) {
        dbList.forEach((d) => {
          mappedList.forEach((data, ind) => {
            if (data.requesttypeid == d.requesttypeid) {
              tempList.push({
                requesttypeid: d.requesttypeid, requesttype: d.requesttype
              });
            }
          });
        });
      }
    }
    mappedList = [];
    mappedList = tempList;
    return tempList;
  }
  confirmation(teammgtid, teammgtname, action) {
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Confirmation',
        message: 'Would you like to save changes? ' + this.currentteam,
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.PostTeamMgt(this.TeamMgtForm.value);
        }
        else {
          this.currentteam = '';
          this.TeamMgtForm.markAsUntouched();
          this.textBoxTocuhed = false;
          this._menuRights.reset();
          this.editTeam(teammgtid, teammgtname, action);
        }
      });

  }

  //click event for edit icon in the grid
  editTeam(teammgtid, teammgtname, action) {
    this.submitShow = true;
    if ((this.currentteam != '') && ((this.TeamMgtForm.touched == true) || (this.textBoxTocuhed == true))) {
      this.confirmation(teammgtid, teammgtname, action);
    }
    else {
      this._menuRights.reset();
      this.currentteam = teammgtname;
      this.TeamMgtForm.value.teammgtid = teammgtid;
      this.TeamMgtForm.value.teammgt = null;
      this.TeamMgtForm.value.databasemapped = '';
      this.TeamMgtForm.value.requestmapped = '';
      this.teamMgtService.Getbyinfo(this.TeamMgtForm.value).subscribe(
        (res) => {
          if (res != undefined) {
            if (JSON.parse(res.body[0].databasemapped) != null)
              this._selectedItems = this.formMultiSelectStrucuture((JSON.parse(res.body[0].databasemapped)).databasemapped, this._databaseListTmp, 'database');
            //(JSON.parse(res.body[0].databasemapped)).databasemapped;
            else
              this._selectedItems = [];
            if (JSON.parse(res.body[0].requestmapped) != null)
              this._selectedRequestType = this.formMultiSelectStrucuture((JSON.parse(res.body[0].requestmapped)).requestmapped, this._requestTypeListTmp, 'request');
            //(JSON.parse(res.body[0].databasemapped)).databasemapped;
            else
              this._selectedRequestType = [];
            this.TeamMgtForm.controls['teammgt'].setValue(res.body[0].teammgt);
            this.TeamMgtForm.controls['description'].setValue(res.body[0].description);
            this._menuRights.teamchange(teammgtid);
            this._action = action;
            this._teamId = res.body[0].teammgtid;
          }
        }, error => {
          //console.log(error);
        });
    }
  }

  //form save json structure for database
  databaseSaveStructure(list, type) {
    var temp = [];
    if (type == 'database') {
      if ((list != null) && (list.length > 0)) {
        list.forEach(item => {
          temp.push({ databaseid: item.databaseid })
        })
      }
    }
    if (type == 'request') {
      if ((list != null) && (list.length > 0)) {
        list.forEach(item => {
          temp.push({ requesttypeid: item.requesttypeid })
        })
      }
    }
    return temp;
  }



  //function to activate or deactivate the team
  statusChange(id, option) {
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    if (option == 'activate') {
      this.confmsg = "activate";
      this.TeamMgtForm.value.active = 1;
      this.msg = "Record activated successfully";
    }
    else {
      this.confmsg = "deactivate";
      this.TeamMgtForm.value.active = 0;
      this.msg = "Record deactivated successfully";
    }
    this.TeamMgtForm.value.teammgtid = id;
    this.TeamMgtForm.value.modifiedby = this.userid;
    this.TeamMgtForm.value.databasemapped = '';
    this.TeamMgtForm.value.requestmapped = '';
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.teamMgtService.Delete(this.TeamMgtForm.value).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success(this.msg);
                this.LoadExisitingTeamList();
              }
              else {
                this.toastr.warning('The team is assigned to the user');
              }
            }, error => {
              //console.log(error);
              this.toastr.error(error);
            });
        }
      });
  }
  LoadRequestTypeList() {
    this.teamMgtService.GetRequestType().subscribe(res => {
      var allData = res;
      allData.forEach(data => {
        if (data.active != 0) {
          this._requestTypeListTmp.push({ requesttypeid: data.requesttypeid, requesttype: data.requesttype })
        }
      });
      this._requestTypeSettings = {
        singleSelection: false,
        idField: 'requesttypeid',
        textField: 'requesttype',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 7,
        allowSearchFilter: true
      };
      this._requestTypeList = JSON.parse(JSON.stringify(this._requestTypeListTmp));
    }, error => { this.toastr.error('Error while getting data'); });
  }

}
function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}

